import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { UserService } from './_services/user.service';
import { AlertComponent } from './_directives/alert.component';
// import { LoginCustom } from './_helpers/login-custom';
// import { Helpers } from '../helpers';
// import 'rxjs/add/operator/catch';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HmacGenerationService } from './_services';
import { ApiService } from '../pages/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page.h-100  ',
    templateUrl: './templates/login-1.component.html',
    styleUrls: ['./templates/login.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
    returnUrl: 'scrappermonitor';
    public disclaimer = false;
    secret_key;
    user_key;
    suberror = [];

    // @ViewChild('alertSignin',
    //     { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    // @ViewChild('alertSignup',
    //     { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    // @ViewChild('alertForgotPass',
    //     { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;

    constructor(
        private _router: Router,
        // private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _alertService: AlertService,
        private cfr: ComponentFactoryResolver,
        private ngxService: NgxUiLoaderService,
        private hmacgen: HmacGenerationService,
        private Service: ApiService,
        private toastr: ToastrService) {
    }
    ngOnInit() {

        this.model.remember = true;
        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
        this._router.navigate([this.returnUrl]);
        // this._script.loadScripts('body', [
        //     'assets/vendors/base/vendors.bundle.js',
        //     'assets/demo/demo10/base/scripts.bundle.js'], true).then(() => {
        //         // Helpers.setLoading(false);
        //         // LoginCustom.init();
        //     });
    }

    signin(formm) {
        this.ngxService.start();
        
        
        this.hmacgen.sample_hmac_gen(
            
            {user_seckey: this.secret_key, user_lkey: this.user_key}).subscribe(
                ress => {
                    let fdata = {
                        data: {},
                        hmac_sig: ress.h_macc,
                        u_key: ress.u_lkey,
                        timestamp: ress.timestamp
                      };

                      this._authService.login(this.model.username, this.model.password).subscribe(
                        data => {
                            if (data) {
                                localStorage.setItem('currentUser', JSON.stringify(data));
                                localStorage.setItem('user_seckey', JSON.stringify(this.secret_key));
                                localStorage.setItem('user_lkey', JSON.stringify(this.user_key));
            
                                this.Service.getscrappermonitorlist(fdata).subscribe(
                                    res => {
                                        this._router.navigate(['scrappermonitor']);
                                        this.ngxService.stop();
                                     
                                       
                        
                                    },
                                    error => {
                                        // this.suberror = [];
                                      
                                    //   if(error.error.error){
                                    //     this.errortext = error.error.error
                              
                                    //   }else{
                                    //     this.errortext = 'Something goes wrong';
                                    //   }
                                    // this.suberror.push({err: error.error.error})
                                    this._router.navigate(['../logout']);
                                    this.toastr.error(error.error.error);
                                    // console.log(error.error.error);
                                      this.ngxService.stop();
                              
                                    }
                                  );
            
                                // Helpers.setLoading(false);
                                this.ngxService.stop();
                            }
                        },
                        error => {
                            this.suberror = [];
                            if (error.status == 0) {
                                this.showAlert('Service Temporarily Unavailable, please try again ');
                                this.outsession(error.status);
                                // for (const property in error.error) {
                                    this.suberror.push({err: "Unknown Error"})
                                //   }
                            }
                            else if (error.status == 400 || error.status == 401) {
                                this.showAlert('Invalid Credentials');
                                for (const property in error.error) {
                                    this.suberror.push({typ: property, err: error.error[property]})
                                  }
                            }
                            else {
                                this.showAlert('Internal Server Error');
                                this.suberror.push({err: "Internal Server Error"})
            
                            }
                            
                            this.ngxService.stop();
            
                        });


                },
                err => {
                    this.suberror = [];
                    this.ngxService.stop();
                    this.suberror.push({err: "Something went wrong"})

                }
            )
        // this.removeAlert();
        // Helpers.setLoading(true);
        
       
    }

    outsession(data) {
        if (data == 0) {
            localStorage.removeItem('currentUser');
            this._router.navigate(['/login'])
        }
    }




    alertpopup = false;
    messageAlert = '';

    removeAlert() {
        this.alertpopup = false;
        this.error = '';
    }

    showAlert(target) {
        this.alertpopup = true;
        this.error = target;
    }
}